module.exports = "//static.hsappstatic.net/pricing-pages-lib/static-1.30225/images/keyFeatures/customer_agent_sales.png"